import React from 'react'
import * as Style from './styled';
import { GET_REQUEST } from '../../../../HooksApi/useApi';
import UseGetData from '../../../../HookAxios/getdata';
import { Link, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Card from '../Card';
import { Skeleton } from '@mui/material';
const PakgeList = ({ filter }) => {
    const { ClassName } = useParams()
    const token = useSelector((state) => state.Auth.userInfo.token)
    const { isLoading, data, isError, error, refetch }
        = GET_REQUEST({
            queryKey: `GetPackages${ClassName}`, request:
                () => UseGetData('get_explore_packages', { search: ClassName }, { "Authorization": `Bearer ${token}` }), enabled: true
        })
    return (
        <Style.Section style={{ display: filter === "1" || filter === "0" ? 'flex' : 'none' }}>
            {
                !isLoading && data.data?.data?.packages ?
                    data?.data?.data?.packages.map((card) =>
                        <Link style={{ textDecoration: 'none' }} to={`/AboutPackeg/${card.id}`}>
                            <Card
                                key={card.id}
                                type="packages"
                                title={card.name}
                                price={card.new_price}
                                oldPrice={card.old_price}
                                imagePath={card.image_path}
                                brife={card.brief} />
                        </Link>
                    )
                    : [...Array(6).keys()].map((sk, i) => <Skeleton key={i} style={{ height: '400px', width: '200px' }} />)
            }
        </Style.Section>
    )
}

export default PakgeList